var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentHistoryDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.6665L12.5869 10.3499C12.4813 12.0574 12.4285 12.9112 12.0005 13.5251C11.7889 13.8286 11.5165 14.0847 11.2005 14.2772C10.5614 14.6665 9.706 14.6665 7.99513 14.6665C6.28208 14.6665 5.42553 14.6665 4.78603 14.2764C4.46987 14.0836 4.19733 13.827 3.98579 13.523C3.55792 12.9082 3.5063 12.0532 3.40307 10.3433L3 3.6665",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66683H14M10.7038 3.66683L10.2487 2.72798C9.9464 2.10434 9.7952 1.79251 9.53447 1.59804C9.47667 1.5549 9.4154 1.51652 9.35133 1.4833C9.0626 1.3335 8.71607 1.3335 8.023 1.3335C7.31253 1.3335 6.95733 1.3335 6.66379 1.48958C6.59873 1.52417 6.53665 1.5641 6.47819 1.60894C6.21443 1.8113 6.06709 2.13453 5.77241 2.781L5.36861 3.66683",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 11V7",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 11V7",
    stroke: "#FF4444",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistoryDelete);
export default __webpack_public_path__ + "static/media/payment-history-delete.517adee99d43858cabbdc624a0d7a4ca.svg";
export { ForwardRef as ReactComponent };